<template>
	
	
		<div class="row ss-select-studio">
			<div class="col-md-6 col-lg-5 p-4">
				<div class="form-group w-100">
					<el-select class="w-100" clearable v-model="studioId" placeholder="Select a studio from dropdown or on map">
						<el-option v-for="l in locations"
											 :key="l.id"
											 :label="l.title"
											 :value="l.id">
							<span style="color: #cc6600" class="float-left">{{l.title}}</span>
							<span class="float-right"><i>{{l.city}}</i></span>
						</el-option>
					</el-select>
				</div>

				<div class="form-group" v-if="selectedStudio">
					<div class="row">
						<div class="col-sm-3 form-group studio-wrapper">
							<img :src="selectedStudio.image" class="img img-fluid" />
						</div>
						<div class="col-sm-9 studio-wrapper">
							<h3 class="mb-1" style="color: #cc6600">{{selectedStudio.title}}</h3>
							<h5>{{selectedStudio.features}}</h5>
							<div class="address">
								<address>
									<ul>
										<li>{{selectedStudio.street}}</li>
										<li>{{selectedStudio.city}} {{selectedStudio.state}} &nbsp;{{selectedStudio.zip}}</li>
										<li>{{selectedStudio.phone}}</li>
									</ul>									
								</address>
								
							</div>
							
						</div>
					</div>
					
					<div class="row">
						<div class="col-6">
							<button type="button" class="btn btn-default btn-lg btn-block" @click="startOver">{{$store.state.steps.one.backButtonText || 'START OVER'}}</button>
						</div>
						<div class="col-6">
							<router-link :to="{ name: 'select-membership'}" tag="a" class="btn btn-primary btn-lg btn-block">{{$store.state.steps.one.nextButtonText}}</router-link>
						</div>
					</div>
					
					
				</div>

			</div>
			<div class="col-md-6 col-lg-7 form-group pr-0 pl-0 ss-signup-map">
				<g-map :center="center" :zoom="zoom" :markers="locations" @mapClicked="handleMapClicked($event)"></g-map>
			</div>
		</div>

	
	
</template>

<script>
	import gmap from "@/components/gmap/gmap.vue";
import { mapGetters } from "vuex";

	export default {
		name: "select-studio",
		components: {
			[gmap.name]: gmap
		},
		data() {
			return {

				zoom: 10,
				center: {
					lat: "32.951549",
					lon: "-96.834894"
				}								
			}
		},

		created() {
			this.zoom = this.mediaZoom;
			
			this.referredBy = this.$route.params.referredBy;
		},
		computed: {
			...mapGetters({
				selectedStudio: "selectedStudio",
				locations: "locations"				
			}),

			studioId: {
				get() {
					return this.$store.state.studioId;
				},
				set(val) {
					this.$store.commit("setLocation", val);
				}
			},

			referredBy: {
				get() {
					return this.$store.state.referredBy;
				},
				set(val) {
					this.$store.commit("setReferral", val);
				}
			},

			mediaZoom() {
				let mq = window.matchMedia("(min-width: 576px)");
				if (mq.matches) {
					return 9;
				}
				mq = window.matchMedia("(min-width: 768px)");
				if (mq.matches) {
					return 9;
				}
				mq = window.matchMedia("(min-width: 992px)");
				if (mq.matches) {
					return 10;
				}
				mq = window.matchMedia("(min-width: 1200px)");
				if (mq.matches) {
					return 10;
				}
				return 9;
			}
		},

		methods: {
			handleMapClicked(evt) {
				
				this.studioId = evt.id;
			},

			startOver() {
				this.studioId = null;
				window.scrollTo(0, 0);
			}
		},

		watch: {
			
			studioId: function (val) {
				if (val) {
					this.center = { lat: this.selectedStudio.lat, lon: this.selectedStudio.lon };
					this.zoom = 20;
				} else {
					this.center = { lat: "32.951549", lon: "-96.834894" };
					this.zoom = this.mediaZoom;
				}
			}
		}
	}
</script>

<style lang="scss">
	.studio-wrapper {
		h3 {
			font-size: 14px;
			line-height:1;
		}
		h5 {
			font-size: 12px;
			line-height: 1;
			margin-bottom:8px;
		}

		.address {
			ul {
				list-style: none;
				margin-left: 0;
				padding-left: 0;
				li {
					font-size: 12px;
					line-height: 14px;
				}
			}
		}
	}

	/* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) {  
 
  }
 
  /* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
  @media (min-width: 768px) {  
 
  }
 
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) { 
		.studio-wrapper {
			h3 {
				font-size: 18px;
				line-height:22px;
			}
			h5 {
				font-size: 14px;
				line-height: 16px;
				margin-bottom:8px;
			}

			.address {
				ul {
					list-style: none;
					margin-left: 0;
					padding-left: 0;
					li {
						font-size: 14px;
						line-height: 16px;
					}
				}
			}
		}
  }
 
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {  
    
  }
</style>